import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw20Handlers = [
  // 掲載媒体情報取得 /kymw20/getPublishMediumInfo
  http.post(
    PlessService.SERVICE.getPublishMediumInfo.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getPublishMediumInfo);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 掲載媒体設定更新 /kymw20/UpdatePublishMediumSetting
  http.post(
    PlessService.SERVICE.updatePublishMediumSetting.url,
    async ({ request }) => {
      const req = await request.json();
      return ResponseUtils.getSuccess();
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 掲載媒体設定更新 /kymw20/UpdatePublishMediumSetting
  http.post(
    PlessService.SERVICE.getCycleMediumList.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getCycleMediumListResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 掲載媒体設定更新 /kymw20/getCycleTempSelectedSummary
  http.post(
    PlessService.SERVICE.getCycleTempSelectedSummary.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getCycleTempSelectedSummaryResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 掲載媒体設定更新 /kymw20/getCycleTempSelectedSummaryByBuyerService
  http.post(
    PlessService.SERVICE.getCycleTempSelectedSummaryByBuyer.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getCycleTempSelectedSummaryByBuyerResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  http.post(
    PlessService.SERVICE.getCycleOrderNumQuotaSelectedSummary.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getCycleOrderNumQuotaSelectedSummaryResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  http.post(
    PlessService.SERVICE.outputCycleOrderNumQuotaSelectedSummary.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(outputOrderNumQuotaSelectedSummaryResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 掲載媒体設定更新 /kymw20/getCycleTempSelectedSummary
  http.post(
    PlessService.SERVICE.getPlanTempSelectedSummary.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getCycleTempSelectedSummaryResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 掲載媒体設定更新 /kymw20/getCycleTempSelectedSummaryByBuyerService
  http.post(
    PlessService.SERVICE.getPlanTempSelectedSummaryByBuyer.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getCycleTempSelectedSummaryByBuyerResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  http.post(
    PlessService.SERVICE.getPlanOrderNumQuotaSelectedSummary.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(getCycleOrderNumQuotaSelectedSummaryResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  http.post(
    PlessService.SERVICE.outputPlanOrderNumQuotaSelectedSummary.url,
    async ({ request }) => {
      const req = await request.json();
      return HttpResponse.json(outputOrderNumQuotaSelectedSummaryResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),
  
];

const getPublishMediumInfo = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      PCode: 'P0000000',
      GuideGoodsName:
        '商品名＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞最大６０文字ＥＮＤ',
      GuideStandardName:
        '規格名＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞＞最大３０文字ＥＮＤ',
      PublishMediumList: [
        {
          IsSelected: false,
          MediumType: '026',
          MediumName: 'ｅフレンズ専用',
        },
        { IsSelected: false, MediumType: '029', MediumName: '新発売' },
        { IsSelected: true, MediumType: '001', MediumName: 'ハピデリ' },
        { IsSelected: false, MediumType: '021', MediumName: 'プチハピ' },
        { IsSelected: false, MediumType: '016', MediumName: 'からだの願い' },
        {
          IsSelected: false,
          MediumType: '023',
          MediumName: 'コスメｄｅきれい（ＣＤ）',
        },
        { IsSelected: false, MediumType: '003', MediumName: 'ぐるめぐり' },
        {
          IsSelected: true,
          MediumType: '004',
          MediumName: 'きらきらベビー',
        },
        {
          IsSelected: false,
          MediumType: '007',
          MediumName: 'ライフスタイル',
        },
        { IsSelected: true, MediumType: '018', MediumName: 'ＩＴ先着順' },
        { IsSelected: false, MediumType: '025', MediumName: '別チラシ６' },
        {
          IsSelected: false,
          MediumType: '006',
          MediumName: 'らくらくコープデリ',
        },
        { IsSelected: false, MediumType: '008', MediumName: '別チラシ３' },
        { IsSelected: false, MediumType: '009', MediumName: '別チラシ４' },
        {
          IsSelected: false,
          MediumType: '080',
          MediumName: 'ハピデリきらきら',
        },
        {
          IsSelected: false,
          MediumType: '081',
          MediumName: 'ヴィナチュール',
        },
        { IsSelected: false, MediumType: '090', MediumName: '使用不可' },
      ],
    },
  },
};

const getCycleMediumListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "MediumType": "001",
        "MediumName": "ハピデリ",
      },
      {
        "MediumType": "991",
        "MediumName": "媒体名1",
      },
      {
        "MediumType": "992",
        "MediumName": "媒体名2",
      },
    ],
  },
};

const getCycleTempSelectedSummaryResponse = {
    "status": "ok",
    "message": "処理完了",
    "result": {
        "obj": {
            "SelectedNumList": [
                {
                    "ClassCode": "02",
                    "ClassName": "水産",
                    "ClassGoodsCount": 9,
                    "FreezedGoodsCount": 9,
                    "RefrigeratedGoodsCount": 0,
                    "RoomTempGoodsCount": 0,
                    "VegetableGoodsCount": 0,
                    "BreadGoodsCount": 0,
                    "OtherStockedGoodsCount": 0
                },
                {
                    "ClassCode": "03",
                    "ClassName": "畜産",
                    "ClassGoodsCount": 4,
                    "FreezedGoodsCount": 4,
                    "RefrigeratedGoodsCount": 0,
                    "RoomTempGoodsCount": 0,
                    "VegetableGoodsCount": 0,
                    "BreadGoodsCount": 0,
                    "OtherStockedGoodsCount": 0
                },
                {
                    "ClassCode": "04",
                    "ClassName": "日配",
                    "ClassGoodsCount": 9,
                    "FreezedGoodsCount": 0,
                    "RefrigeratedGoodsCount": 9,
                    "RoomTempGoodsCount": 0,
                    "VegetableGoodsCount": 0,
                    "BreadGoodsCount": 0,
                    "OtherStockedGoodsCount": 0
                },
                {
                    "ClassCode": "05",
                    "ClassName": "菓子",
                    "ClassGoodsCount": 45,
                    "FreezedGoodsCount": 0,
                    "RefrigeratedGoodsCount": 3,
                    "RoomTempGoodsCount": 40,
                    "VegetableGoodsCount": 0,
                    "BreadGoodsCount": 2,
                    "OtherStockedGoodsCount": 0
                },
                {
                    "ClassCode": "06",
                    "ClassName": "食品",
                    "ClassGoodsCount": 70,
                    "FreezedGoodsCount": 0,
                    "RefrigeratedGoodsCount": 0,
                    "RoomTempGoodsCount": 70,
                    "VegetableGoodsCount": 0,
                    "BreadGoodsCount": 0,
                    "OtherStockedGoodsCount": 0
                },
                {
                    "ClassCode": "08",
                    "ClassName": "加工肉",
                    "ClassGoodsCount": 2,
                    "FreezedGoodsCount": 0,
                    "RefrigeratedGoodsCount": 2,
                    "RoomTempGoodsCount": 0,
                    "VegetableGoodsCount": 0,
                    "BreadGoodsCount": 0,
                    "OtherStockedGoodsCount": 0
                },
                {
                    "ClassCode": "09",
                    "ClassName": "パン生菓子",
                    "ClassGoodsCount": 1,
                    "FreezedGoodsCount": 0,
                    "RefrigeratedGoodsCount": 0,
                    "RoomTempGoodsCount": 0,
                    "VegetableGoodsCount": 0,
                    "BreadGoodsCount": 1,
                    "OtherStockedGoodsCount": 0
                },
                {
                    "ClassCode": "10",
                    "ClassName": "酒",
                    "ClassGoodsCount": 8,
                    "FreezedGoodsCount": 0,
                    "RefrigeratedGoodsCount": 0,
                    "RoomTempGoodsCount": 8,
                    "VegetableGoodsCount": 0,
                    "BreadGoodsCount": 0,
                    "OtherStockedGoodsCount": 0
                },
                {
                    "ClassCode": "15",
                    "ClassName": "冷食・アイス",
                    "ClassGoodsCount": 16,
                    "FreezedGoodsCount": 16,
                    "RefrigeratedGoodsCount": 0,
                    "RoomTempGoodsCount": 0,
                    "VegetableGoodsCount": 0,
                    "BreadGoodsCount": 0,
                    "OtherStockedGoodsCount": 0
                }
            ],
            "SelectedTotalNum": {
                "ClassGoodsCount": 164,
                "FreezedGoodsCount": 29,
                "RefrigeratedGoodsCount": 14,
                "RoomTempGoodsCount": 118,
                "VegetableGoodsCount": 0,
                "BreadGoodsCount": 3,
                "OtherStockedGoodsCount": 0
            }
        }
    }
};

const getCycleTempSelectedSummaryByBuyerResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      SelectedNumList: [
        {
          MediumType: "001",
          MediumName: "ハピデリ",
          ClassCode: "01",
          ClassName: "日配",
          BuyerCode: "00100001",
          BuyerName: "A",
          FreezedGoodsCount: "90",
          RefrigeratedGoodsCount: "30",
          RoomTempGoodsCount: "50",
          VegetableGoodsCount: "55",
          BreadGoodsCount: "95",
          OtherStockedGoodsCount: "60"
        },
        {
          MediumType: "001",
          MediumName: "ハピデリ",
          ClassCode: "02",
          ClassName: "パン",
          BuyerCode: "00100002",
          BuyerName: "B",
          FreezedGoodsCount: "90",
          RefrigeratedGoodsCount: "30",
          RoomTempGoodsCount: "50",
          VegetableGoodsCount: "55",
          BreadGoodsCount: "95",
          OtherStockedGoodsCount: "60"
        },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
        // {
        //   MediumType: "001",
        //   MediumName: "ハピデリ",
        //   ClassCode: "02",
        //   ClassName: "パン",
        //   BuyerCode: "00100002",
        //   BuyerName: "B",
        //   FreezedGoodsCount: "90",
        //   RefrigeratedGoodsCount: "30",
        //   RoomTempGoodsCount: "50",
        //   VegetableGoodsCount: "55",
        //   BreadGoodsCount: "95",
        //   OtherStockedGoodsCount: "60"
        // },
      ],
      SelectedTotalNum: {
        FreezedGoodsCount: "180",
        RefrigeratedGoodsCount: "60",
        RoomTempGoodsCount: "100",
        VegetableGoodsCount: "110",
        BreadGoodsCount: "190",
        OtherStockedGoodsCount: "120"
      }
    }
  }
};

const getCycleOrderNumQuotaSelectedSummaryResponse = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": {
      "SelectedNumList": [
        {
          "ClassCode": "01",
          "ClassName": "農産",
          "IbarakiGoodsCount": 8,
          "TochigiGoodsCount": 8,
          "GunmaGoodsCount": 8,
          "ChibaGoodsCount": 8,
          "SaitamaGoodsCount": 8,
          "TokyoGoodsCount": 8,
          "NaganoGoodsCount": 8,
          "NiigataGoodsCount": 8
        },
        {
          "ClassCode": "02",
          "ClassName": "水産",
          "IbarakiGoodsCount": 14,
          "TochigiGoodsCount": 14,
          "GunmaGoodsCount": 14,
          "ChibaGoodsCount": 14,
          "SaitamaGoodsCount": 14,
          "TokyoGoodsCount": 14,
          "NaganoGoodsCount": 14,
          "NiigataGoodsCount": 14
        },
        {
          "ClassCode": "03",
          "ClassName": "畜産",
          "IbarakiGoodsCount": 17,
          "TochigiGoodsCount": 17,
          "GunmaGoodsCount": 17,
          "ChibaGoodsCount": 17,
          "SaitamaGoodsCount": 17,
          "TokyoGoodsCount": 17,
          "NaganoGoodsCount": 17,
          "NiigataGoodsCount": 17
        },
        {
          "ClassCode": "04",
          "ClassName": "日配",
          "IbarakiGoodsCount": 81,
          "TochigiGoodsCount": 81,
          "GunmaGoodsCount": 81,
          "ChibaGoodsCount": 81,
          "SaitamaGoodsCount": 81,
          "TokyoGoodsCount": 81,
          "NaganoGoodsCount": 81,
          "NiigataGoodsCount": 81
        },
        {
          "ClassCode": "05",
          "ClassName": "菓子",
          "IbarakiGoodsCount": 33,
          "TochigiGoodsCount": 33,
          "GunmaGoodsCount": 33,
          "ChibaGoodsCount": 33,
          "SaitamaGoodsCount": 33,
          "TokyoGoodsCount": 33,
          "NaganoGoodsCount": 33,
          "NiigataGoodsCount": 33
        },
        {
          "ClassCode": "06",
          "ClassName": "食品",
          "IbarakiGoodsCount": 270,
          "TochigiGoodsCount": 270,
          "GunmaGoodsCount": 270,
          "ChibaGoodsCount": 270,
          "SaitamaGoodsCount": 270,
          "TokyoGoodsCount": 270,
          "NaganoGoodsCount": 270,
          "NiigataGoodsCount": 270
        },
        {
          "ClassCode": "07",
          "ClassName": "住関連",
          "IbarakiGoodsCount": 248,
          "TochigiGoodsCount": 248,
          "GunmaGoodsCount": 248,
          "ChibaGoodsCount": 248,
          "SaitamaGoodsCount": 248,
          "TokyoGoodsCount": 248,
          "NaganoGoodsCount": 248,
          "NiigataGoodsCount": 248
        },
        {
          "ClassCode": "08",
          "ClassName": "加工肉",
          "IbarakiGoodsCount": 16,
          "TochigiGoodsCount": 16,
          "GunmaGoodsCount": 16,
          "ChibaGoodsCount": 16,
          "SaitamaGoodsCount": 16,
          "TokyoGoodsCount": 16,
          "NaganoGoodsCount": 16,
          "NiigataGoodsCount": 16
        },
        {
          "ClassCode": "09",
          "ClassName": "パン生菓子",
          "IbarakiGoodsCount": 10,
          "TochigiGoodsCount": 10,
          "GunmaGoodsCount": 10,
          "ChibaGoodsCount": 10,
          "SaitamaGoodsCount": 10,
          "TokyoGoodsCount": 10,
          "NaganoGoodsCount": 10,
          "NiigataGoodsCount": 10
        },
        {
          "ClassCode": "10",
          "ClassName": "酒",
          "IbarakiGoodsCount": 18,
          "TochigiGoodsCount": 18,
          "GunmaGoodsCount": 18,
          "ChibaGoodsCount": 18,
          "SaitamaGoodsCount": 18,
          "TokyoGoodsCount": 18,
          "NaganoGoodsCount": 18,
          "NiigataGoodsCount": 18
        },
        {
          "ClassCode": "11",
          "ClassName": "米",
          "IbarakiGoodsCount": 0,
          "TochigiGoodsCount": 0,
          "GunmaGoodsCount": 0,
          "ChibaGoodsCount": 0,
          "SaitamaGoodsCount": 0,
          "TokyoGoodsCount": 0,
          "NaganoGoodsCount": 0,
          "NiigataGoodsCount": 0
        },
        {
          "ClassCode": "14",
          "ClassName": "たまご・牛乳",
          "IbarakiGoodsCount": 1,
          "TochigiGoodsCount": 1,
          "GunmaGoodsCount": 1,
          "ChibaGoodsCount": 1,
          "SaitamaGoodsCount": 1,
          "TokyoGoodsCount": 1,
          "NaganoGoodsCount": 1,
          "NiigataGoodsCount": 1
        },
        {
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "IbarakiGoodsCount": 81,
          "TochigiGoodsCount": 81,
          "GunmaGoodsCount": 81,
          "ChibaGoodsCount": 81,
          "SaitamaGoodsCount": 81,
          "TokyoGoodsCount": 81,
          "NaganoGoodsCount": 81,
          "NiigataGoodsCount": 81
        },
        {
          "ClassCode": "16",
          "ClassName": "惣菜",
          "IbarakiGoodsCount": 46,
          "TochigiGoodsCount": 46,
          "GunmaGoodsCount": 46,
          "ChibaGoodsCount": 46,
          "SaitamaGoodsCount": 46,
          "TokyoGoodsCount": 46,
          "NaganoGoodsCount": 46,
          "NiigataGoodsCount": 46
        }
      ],
      "SelectedTotalNum": {
        "IbarakiGoodsCount": 843,
        "TochigiGoodsCount": 843,
        "GunmaGoodsCount": 843,
        "ChibaGoodsCount": 843,
        "SaitamaGoodsCount": 843,
        "TokyoGoodsCount": 843,
        "NaganoGoodsCount": 843,
        "NiigataGoodsCount": 843
      },
      "MaxNum": {
        "IbarakiGoodsCount": 0,
        "TochigiGoodsCount": 0,
        "GunmaGoodsCount": 0,
        "ChibaGoodsCount": 0,
        "SaitamaGoodsCount": 0,
        "TokyoGoodsCount": 0,
        "NaganoGoodsCount": 0,
        "NiigataGoodsCount": 0
      }
    }
  }
};

const outputOrderNumQuotaSelectedSummaryResponse = {
  "status": "ok",
  "message": "処理終了",
  "result": {
    "obj": {
      "FileName": "/tmp/peace/data/WebData/downloadtemp/KYMW2000_2023160_001_001_20240814_161931.xls"
    }
  }
}